<template>
    <div class="w-100" style="padding-right: 75px">
        <c-app-home-bar
            :search-on-focus = "searchOnFocus"
        />

        <div
            v-if = "!sites && !hideTop"
            class="primary top-empty"
        >
        </div>

        <c-site-data-row
            v-if   = "sites"
            :sites = "sites"
            style  = "min-height: 142px"
        />

        <v-container class="content-panel">
            <slot name="content"></slot>
        </v-container>
    </div>
</template>

<script>

import Core         from "@/modules/core/service/Core";
import CAppHomeBar  from "@/modules/core/components/app/CAppHomeBar";
import CSiteDataRow from "@/modules/msd/unit/components/top/CSiteDataRow";

export default {
    name: "CAppContent",

    components: {
        CSiteDataRow,
        CAppHomeBar
    },

    props: {
        sites: {

        },

        hideTop: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        searchOnFocus: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
    },

    data: () => ({
    }),

    mounted () {
        Core.init.load(this.$store, false).then(() => {
            Core.fire.initialized(this);
        })
    },

    watch: {
        params () {
            Core.fire.initialized(this);
        }
    },

    computed: {
        params () {
            return this.$route.params;
        }
    },

    methods: {
    }
}
</script>

<style scoped>

.content-panel {
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    padding: 0;
}

.top-empty {
    height: 100px;
    margin-left: 75px;
    width: calc(100% - 75px);
}

</style>